export default {
    okmain:{
      lang:"中文(简体)",
      openkylinweburl:'https://www.openkylin.top/',
      openkylinsigurl:'https://www.openkylin.top/sig/application-cn.html',
      openkylinmemberurl:'https://www.openkylin.top/community/partner-cn.html',
      nav1:"数据总览",
      nav2:"社区贡献",
      nav3:"返回官网",
      user:"用户 Users",
      contributors:"贡献者 Contributors",
      member:"社区会员 Members",
      sig:"特别兴趣小组 SIG",
      repositories:"代码仓库 Repositories",
      commits:"提交请求 Commits",
      pr:"合并请求 PR",
      issues:"需求&问题 Issues",
      f_copyright:"Copyright©2023 openKylin 版权所有",
      f_garight:"津公网安备12011602001167号",
      f_code:"代码仓库",
      f_joinmember:"加入会员",
      f_joinsig:"加入SIG",
      f_updatetime:"更新时间",
      f_frequency:"频率",
      f_times:"小时一次",
      c_devel_contribute:"开发者贡献",
      c_time1:'一个月内',
      c_time2:'半年内',
      c_time3:'一年内',
      c_all:'全部',
      c_metrics:'度量指标',
      c_points:'积分',
      c_range:'显示范围',
      c_sort:'排序',
      c_giteename:"Gitee名",
      c_communityname:"社区名",
      c_contributionvalue:"贡献值",
      c_pointvalue:"积分值",



    }
  };
  


// WEBPACK FOOTER //
// ./src/local/language/cn.js